import { format, isValid, parseISO } from "date-fns";

// hlm_user.birth_date is free text, and earlier dashboard versions wrote "MM/DD/YYYY" and ISO timestamps next
// to today's "yyyy-MM-dd". Only a real "yyyy-MM-dd" is a calendar day that new Date() would misread.
const ISO_DAY = /^\d{4}-\d{2}-\d{2}$/;

const isIsoDay = value => typeof value === "string" && ISO_DAY.test(value) && isValid(parseISO(value));

/**
 * The date a birth-date calendar shows for a stored or typed value.
 *
 * A "yyyy-MM-dd" is read as local midnight of that day. new Date("1990-05-01") is UTC midnight, which west of
 * UTC is the evening of the day before, so the calendar showed the previous day and the form then saved it.
 * Any other shape goes through new Date() as it always did ("MM/DD/YYYY" as a local day, an ISO timestamp as
 * the moment it names).
 *
 * @param {string|null|undefined} value
 * @returns {Date|null} null when there is no value; an Invalid Date when the text is no date
 */
export const parseBirthDate = value => {
  if (!value) {
    return null;
  }

  return isIsoDay(value) ? parseISO(value) : new Date(value);
};

/**
 * The birth_date to send to /my-account/personal-info.
 *
 * A valid "yyyy-MM-dd" is sent as it is, so saving another field never moves the date. Anything else is
 * written as the local calendar day it names, as before: a picked "MM/DD/YYYY" becomes "yyyy-MM-dd". No value
 * gives "", which the backend ignores. An impossible date throws a RangeError, as format() always did here.
 *
 * @param {string|null|undefined} value
 * @returns {string}
 */
export const toStoredBirthDate = value => {
  if (!value) {
    return "";
  }

  return isIsoDay(value) ? value : format(new Date(value), "yyyy-MM-dd");
};
